import React, { useState, useContext } from "react";

import {
  Button as MuiButton,
  Grid,
  Modal as MuiModal,
  Paper,
  Box,
} from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import { api } from "../../../../services/Api";
import Button from "../../../../componentsv2/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSnackbar } from "notistack";
import { Modal } from "../../../../componentsv2/Modal";
import { Context as PermissoesContext } from "../../../../Context/PermissoesContext.js";

export default function Opcoes({ row, setId, setMaterialModal, setUpdate, update }) {
  const [open, setOpen] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [openModalAtivar, setOpenModalAtivar] = useState(false);
  const [openModalDesativar, setOpenModalDesativar] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { checarPermissao } = useContext(PermissoesContext);

  function ModalOption(props) {
    const handleDelete = async () => {
      if (!props.row.id) return;

      try {
        await api.delete(`/v2/inventario/material/${props.row.id}`);
        setOpen(false);
        setUpdate(!update);
        enqueueSnackbar("Material excluído com sucesso!", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } catch (error) {
        const mensagem = error.response?.data?.messages || 
                         error.response?.data?.message || 
                         error.response?.data?.error || 
                         "Erro ao tentar excluir o material!";
        enqueueSnackbar(mensagem, {
          variant: "error",
          autoHideDuration: 5000,
        });
      }
    };

    const handleAtivar = async () => {
      if (!props.row.id) return;

      try {
        await api.put(`/v2/inventario/material/${props.row.id}`, {
          marca: props.row.marca,
          modelo: props.row.modelo,
          descricao: props.row.descricao,
          tipoMaterialId: props.row.tipoMaterialId,
          ativo: true,
        });
        setOpen(false);
        setUpdate(!update);
        enqueueSnackbar("Material ativado com sucesso!", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } catch (error) {
        enqueueSnackbar("Erro ao tentar ativar o material!", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    };

    const handleDesativar = async () => {
      if (!props.row.id) return;

      try {
        await api.put(`/v2/inventario/material/${props.row.id}`, {
          marca: props.row.marca,
          modelo: props.row.modelo,
          descricao: props.row.descricao,
          tipoMaterialId: props.row.tipoMaterialId,
          ativo: false,
        });
        setOpen(false);
        setUpdate(!update);
        enqueueSnackbar("Material desativado com sucesso!", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } catch (error) {
        const mensagem = error.response?.data?.messages || 
                         error.response?.data?.message || 
                         error.response?.data?.error || 
                         "Erro ao tentar desativar o material!";
        enqueueSnackbar(mensagem, {
          variant: "error",
          autoHideDuration: 5000,
        });
      }
    };

    const handleClickEdit = () => {
      if (!checarPermissao("INV016")) {
        enqueueSnackbar("Você não possui permissão para editar um material!", {
          variant: "error",
          autoHideDuration: 3000,
        });
        return;
      }
      setId(props.row.id);
      setMaterialModal(true);
    };

    const verificarPermissaoEAbrirModal = (permissao, setModal, mensagemErro) => {
      if (!checarPermissao(permissao)) {
        enqueueSnackbar(mensagemErro, {
          variant: "error",
          autoHideDuration: 3000,
        });
        return;
      }
      setModal(true);
    };
    return (
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "300px",
          outline: "none",
        }}
      >
        <Paper 
          className="options-paper" 
          elevation={2}
          sx={{
            padding: "1rem",
          }}
        >
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <Button
                onClick={handleClickEdit}
                variant="standard"
                startIcon={<EditIcon />}
                fullWidth
              >
                Editar
              </Button>
            </Grid>
            {props.row.ativo === true ? (
              <>
                <Grid item sm={12}>
                  <Button
                    onClick={() =>
                      verificarPermissaoEAbrirModal(
                        "INV016",
                        setOpenModalDesativar,
                        "Você não possui permissão para desativar um material!"
                      )
                    }
                    variant="standard"
                    startIcon={<CancelIcon />}
                    fullWidth
                  >
                    Desativar
                  </Button>
                  <Modal
                    open={openModalDesativar}
                    confirmActionButtonText="Desativar"
                    onClick={handleDesativar}
                    confirmActionButtonColor="red"
                    onClose={setOpenModalDesativar}
                    modalText="Tem certeza que deseja desativar este material? Ele não aparecerá mais na lista."
                  />
                </Grid>
                <Grid item sm={12}>
                  <Button
                    onClick={() =>
                      verificarPermissaoEAbrirModal(
                        "INV017",
                        setOpenModalConfirmacao,
                        "Você não possui permissão para excluir um material!"
                      )
                    }
                    variant="standard"
                    startIcon={<DeleteIcon />}
                    fullWidth
                  >
                    Excluir
                  </Button>
                  <Modal
                    open={openModalConfirmacao}
                    confirmActionButtonText="Remover"
                    onClick={handleDelete}
                    confirmActionButtonColor="red"
                    onClose={setOpenModalConfirmacao}
                    modalText="Tem certeza que deseja remover este material?"
                  />
                </Grid>
              </>
            ) : (
              <Grid item sm={12}>
                <Button
                  onClick={() =>
                    verificarPermissaoEAbrirModal(
                      "INV016",
                      setOpenModalAtivar,
                      "Você não possui permissão para ativar um material!"
                    )
                  }
                  variant="standard"
                  startIcon={<CheckCircleIcon />}
                  fullWidth
                >
                  Ativar
                </Button>
                <Modal
                  open={openModalAtivar}
                  confirmActionButtonText="Ativar"
                  onClick={handleAtivar}
                  confirmActionButtonColor="green"
                  onClose={setOpenModalAtivar}
                  modalText="Deseja ativar este material? Ele aparecerá na lista."
                />
              </Grid>
            )}
            <Grid item sm={12}>
              <Button
                onClick={() => setOpen(false)}
                variant="standard"
                startIcon={<ArrowBackIcon />}
                fullWidth
              >
                Voltar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    );
  }

  return (
    <>
      <MuiButton style={{ color: "#000" }} onClick={() => setOpen(true)}>
        <SettingsIcon />
      </MuiButton>
      <MuiModal open={open} onClose={() => setOpen(false)}>
        <ModalOption row={row} setUpdate={setUpdate} update={update} />
      </MuiModal>
    </>
  );
}
